import { TableHead, TableHeader, TableRow } from '@/components/ui';

export const DataTableHeader = () => (
  <TableHeader>
    <TableRow>
      <TableHead />
      <TableHead>
        Nom
      </TableHead>
      <TableHead>
        Email
      </TableHead>
      <TableHead>
        Permissions
      </TableHead>
      <TableHead className='text-right'>
        Ajouté le
      </TableHead>
      <TableHead />
    </TableRow>
  </TableHeader>
);

export default DataTableHeader;
